'use client';

import { Button } from '../ui/button';

const CustomButton = ({ text, handler, disabled = false }) => {
    return (
        <Button onClick={handler} disabled={disabled}>
            {text}
        </Button>
    );
};

export default CustomButton;
